// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chats-list-container {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.chats-list-container td,
.chats-list-container th {
    text-align: center;
}

.chats-list__header {
    margin: 1.5rem 4rem;
    display: flex;
    align-items: flex-end;
    height: 4rem;
}

.chats-list__search-mode {
    display: flex;
    flex-wrap: nowrap;
    margin-right: 3rem;
    border-bottom: 1px solid rgb(161, 161, 161);
}

.chats-list__search-mode span{
    margin-left: .5rem;
    margin-right: .5rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: medium;
    cursor: pointer;
    padding-bottom: 0.2rem;
    margin-bottom: -2px;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    white-space: nowrap;
}

.chats-list__search-mode span.active{
    font-weight: bold;
    border-bottom: 2px solid #26a69a;
}

.chats-list__search {
    float: right;
    width: 30%;
}

.chats-list__search-mode .active {
    opacity: 1;
}

.chats-list__search-mode__all-chats {
    position: absolute;
    margin-top: -1.5rem;
    margin-left: -3rem;
    opacity: .5;
}

.chats-list__search-mode__my-chats {
    position: absolute;
    margin-top: -1.5rem;
    margin-left: -1rem;
    opacity: .5;
}

.chats-list__btn-more {
    width: 4rem;
    padding: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: 1rem;
}

.chat-item__chat-id-cell {
    width: 1rem;
    text-align: left;
}

.chat-item__channel-info-cell {
    margin-left: 10rem;
}

.chats-list__body {
    overflow: auto;
    height: calc(100vh - 17.5rem);
}

.chats-list__body.splittered {
    left: 1rem;
    right: 0rem;
}

.auto-update-chats-container {
    font-size: large;
    width: fit-content;
    margin-left: 3rem;
    display: flex;
    align-items: center;
}

.auto-update-chats-check svg{
    font-size: large;
}

.auto-update-chats-container span {
    line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/chats/chats-main/chats-list/ChatsList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".chats-list-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n}\r\n\r\n.chats-list-container td,\r\n.chats-list-container th {\r\n    text-align: center;\r\n}\r\n\r\n.chats-list__header {\r\n    margin: 1.5rem 4rem;\r\n    display: flex;\r\n    align-items: flex-end;\r\n    height: 4rem;\r\n}\r\n\r\n.chats-list__search-mode {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    margin-right: 3rem;\r\n    border-bottom: 1px solid rgb(161, 161, 161);\r\n}\r\n\r\n.chats-list__search-mode span{\r\n    margin-left: .5rem;\r\n    margin-right: .5rem;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    font-size: medium;\r\n    cursor: pointer;\r\n    padding-bottom: 0.2rem;\r\n    margin-bottom: -2px;\r\n    -moz-user-select: none;\r\n    -khtml-user-select: none;\r\n    user-select: none;\r\n    white-space: nowrap;\r\n}\r\n\r\n.chats-list__search-mode span.active{\r\n    font-weight: bold;\r\n    border-bottom: 2px solid #26a69a;\r\n}\r\n\r\n.chats-list__search {\r\n    float: right;\r\n    width: 30%;\r\n}\r\n\r\n.chats-list__search-mode .active {\r\n    opacity: 1;\r\n}\r\n\r\n.chats-list__search-mode__all-chats {\r\n    position: absolute;\r\n    margin-top: -1.5rem;\r\n    margin-left: -3rem;\r\n    opacity: .5;\r\n}\r\n\r\n.chats-list__search-mode__my-chats {\r\n    position: absolute;\r\n    margin-top: -1.5rem;\r\n    margin-left: -1rem;\r\n    opacity: .5;\r\n}\r\n\r\n.chats-list__btn-more {\r\n    width: 4rem;\r\n    padding: 0;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    margin-top: 1rem;\r\n}\r\n\r\n.chat-item__chat-id-cell {\r\n    width: 1rem;\r\n    text-align: left;\r\n}\r\n\r\n.chat-item__channel-info-cell {\r\n    margin-left: 10rem;\r\n}\r\n\r\n.chats-list__body {\r\n    overflow: auto;\r\n    height: calc(100vh - 17.5rem);\r\n}\r\n\r\n.chats-list__body.splittered {\r\n    left: 1rem;\r\n    right: 0rem;\r\n}\r\n\r\n.auto-update-chats-container {\r\n    font-size: large;\r\n    width: fit-content;\r\n    margin-left: 3rem;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.auto-update-chats-check svg{\r\n    font-size: large;\r\n}\r\n\r\n.auto-update-chats-container span {\r\n    line-height: 1;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
